export class DealerFilter {
  private readonly locations: Map<string, HTMLElement> = new Map();
  private readonly locationWrapper: Map<number, HTMLElement> = new Map();
  private selectFilter: HTMLSelectElement;

  public static init(): DealerFilter | void {
    const filters = document.querySelectorAll(".dealers-filter");
    filters.forEach((filter) =>
      filter ? new DealerFilter(filter as HTMLElement) : false
    );
  }

  constructor(private readonly filter: HTMLElement) {
    this.filter.parentElement
      .querySelectorAll<HTMLElement>(".item-wrapper")
      .forEach((location, id) => {
        this.locations.set(location.getAttribute("data-location"), location);
        this.locationWrapper.set(id, location);
      });

    this.selectFilter = this.filter.querySelector("select");
    this.setOptions();
    this.onChangeFilter();
  }
  private getLocations(): Array<string> {
    let locationName: Array<string> = [];

    for (const location of this.locations) {
      locationName.push(location[0]);
    }

    locationName.sort((a, b) => {
      const nameA = a.toUpperCase();
      const nameB = b.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    return locationName;
  }

  private setOptions(): void {
    const locations = this.getLocations();
    locations.forEach((location) => {
      let option = document.createElement("option");
      option.innerText = location;
      option.setAttribute("value", location);

      this.selectFilter.appendChild(option);
    });
  }

  private onChangeFilter(): void {
    this.selectFilter.addEventListener("change", (e) => {
      const selectedValue: string = this.selectFilter.value;

      this.filter
        .closest<HTMLDivElement>(".dealers")
        .setAttribute("data-show", this.selectFilter.value);
      this.locationWrapper.forEach((item) => {
        if (selectedValue === "global") {
          item.style.removeProperty("display");
        } else if (item.getAttribute("data-location") !== selectedValue) {
          item.style.display = "none";
        } else {
          item.style.removeProperty("display");
        }
      });
    });
  }
}
